/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ResourceTypeDto = {
    Contact: 'CONTACT',
    Customer: 'CUSTOMER',
    Process: 'PROCESS',
    ProcessOffer: 'PROCESS_OFFER',
    Email: 'EMAIL',
    User: 'USER',
    Task: 'TASK',
    Supplier: 'SUPPLIER',
    IncidentTicket: 'INCIDENT_TICKET',
    Car: 'CAR',
    Chat: 'CHAT',
    SettlementPayment: 'SETTLEMENT_PAYMENT',
    CarLogEntry: 'CAR_LOG_ENTRY',
} as const;

export type ResourceTypeDto = typeof ResourceTypeDto[keyof typeof ResourceTypeDto];



